import {Component, OnInit} from '@angular/core';
import {NavController} from '@ionic/angular';
import {select, Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import * as apiVeranstaltungen from '../../../../clients/veranstaltungen';
import * as actionsUi from './veranstaltung-main.actions.ui';
import {ActivatedRoute, Router} from '@angular/router';
import {SafeUrl} from '@angular/platform-browser';
import { Settings, SettingsProvider } from '@orga-app/settings';
import {getAktuelleVeranstaltung, getAktuelleVeranstaltungZuletztGewaehlt} from '../../app-state/app-state.reducer';

@Component({
    selector: 'app-veranstaltung-main',
    templateUrl: './veranstaltung-main.page.html',
})
export class VeranstaltungMainPage implements OnInit {
    public settings$: Observable<Settings>;
    public themeDefault$: Observable<Settings>;
    public logoHeaderSVG$: Observable<SafeUrl>;
    private aiName = 'VeranstaltungMainPage';
    public aktuelleVeranstaltungZuletztGewaehlt$: Observable<apiVeranstaltungen.Veranstaltung>;
    public aktuelleVeranstaltung$: Observable<apiVeranstaltungen.Veranstaltung>;

    routeForOutlet: string;

    public selectedTab: string;
    heute: Date;

    constructor(public navCtrl: NavController,
                private store: Store<any>,
                private settingsProvider: SettingsProvider,
                public route: ActivatedRoute,
                public router: Router
    ) {
        this.themeDefault$ = this.settingsProvider.getThemeDefault();
        this.logoHeaderSVG$ = this.settingsProvider.getLogoHeaderSVG();
        this.settings$ = this.settingsProvider.getActiveTheme();

        // Default-Routing
        this.routeForOutlet = '/veranstaltung/info';
        this.selectedTab = 'info';
    }

    ngOnInit() {
        // Veranstaltung
        this.aktuelleVeranstaltung$ = this.store.pipe(select(getAktuelleVeranstaltung));
        this.aktuelleVeranstaltungZuletztGewaehlt$ = this.store.pipe(select(getAktuelleVeranstaltungZuletztGewaehlt));
    }

    ionViewWillEnter() {
        this.heute = new Date();
        this.viewWillEnterPage().then();

        this.router.navigateByUrl(this.routeForOutlet);
    }

    async viewWillEnterPage() {
        console.debug('STARTING :: AufgabenBerechtigungenChecklistenPage :: viewWillEnterPage :: PageStateResetAction');
        this.store.dispatch(new actionsUi.PageStateResetAction());
        await this.ladeDaten();
    }

    ionViewWillLeave() {
    }

    async ladeDaten() {
        this.store.dispatch(new actionsUi.PageLoadDataAction());
    }

    merkeRoute($event, route: string) {
        this.routeForOutlet = route;
        this.router.navigateByUrl(route);
    }

    veranstaltungWechseln() {
        this.router.navigate(['/veranstaltung-auswaehlen', { returnTo: window.location.pathname }],
            {
                preserveFragment: true
            });
    }
}
